import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getNotesByUserId,
  createNote,
  updateNote,
  deleteNote,
} from "./notes";
import { toast } from "react-toastify";

export const useNotes = (userId: string) => {
  const queryClient = useQueryClient();

  // FETCH NOTES
  const notesQuery = useQuery({
    queryKey: ["notes", userId],
    enabled: !!userId,
    queryFn: () => getNotesByUserId(userId),
    staleTime: 5 * 60 * 1000,
  });

  // CREATE
  const createNoteMutation = useMutation({
    mutationFn: (text: string) => createNote(text),
    onSuccess: () => {
      toast.success("Note added");
      queryClient.invalidateQueries({ queryKey: ["notes", userId] });
    },
  });

  // UPDATE
  const updateNoteMutation = useMutation({
    mutationFn: ({ id, text }: { id: string; text: string }) =>
      updateNote(id, text),
    onSuccess: () => {
      toast.success("Note updated");
     queryClient.invalidateQueries({ queryKey: ["notes", userId] });
    },
  });

  // DELETE
  const deleteNoteMutation = useMutation({
    mutationFn: (id: string) => deleteNote(id),
    onSuccess: () => {
      toast.success("Note removed");
      queryClient.invalidateQueries({ queryKey: ["notes", userId] });
    },
  });

  return {
    notesQuery,
    createNoteMutation,
    updateNoteMutation,
    deleteNoteMutation,
  };
};
